var _g;

const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

const SvgReceipt = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-46 40)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M66-36v15.5l-2.173-1.63a3.018,3.018,0,0,0-1.8-.6,3.01,3.01,0,0,0-1.9.683L58-20.3l-2.123-1.745a3.01,3.01,0,0,0-1.9-.683,3.018,3.018,0,0,0-1.8.6L50-20.5V-36H66m0-2H50a2,2,0,0,0-2,2v16a2,2,0,0,0,1.484,1.933.933.933,0,0,0,.234.03,1.02,1.02,0,0,0,.607-.207l3.047-2.285a1,1,0,0,1,.6-.2,1,1,0,0,1,.635.228l2.5,2.054a1.994,1.994,0,0,0,.894.211,1.994,1.994,0,0,0,.894-.211l2.5-2.054a1,1,0,0,1,.635-.228,1,1,0,0,1,.6.2l3.047,2.285a1.02,1.02,0,0,0,.607.207.933.933,0,0,0,.234-.03A2,2,0,0,0,68-20V-36a2,2,0,0,0-2-2Zm-7,6a1,1,0,0,0-1-1H53a1,1,0,0,0-1,1,1,1,0,0,0,1,1h5A1,1,0,0,0,59-32Zm-2,4a1,1,0,0,0-1-1H53a1,1,0,0,0-1,1,1,1,0,0,0,1,1h3A1,1,0,0,0,57-28Zm7-4a1,1,0,0,0-1-1H61a1,1,0,0,0-1,1,1,1,0,0,0,1,1h2A1,1,0,0,0,64-32Z"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgReceipt, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/receipt.487341b5.svg";
export { ForwardRef as ReactComponent };